import React, { useEffect, useState } from 'react';
import './AnimatedLogo.css';
import logo from '../../assets/GoesGreen-300x74.png';

const AnimatedLogo = ({ visible, children }) => {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
    } else {
      const timeout = setTimeout(() => setShouldRender(false), 500);
      return () => clearTimeout(timeout);
    }
  }, [visible]);

  return (
    shouldRender && (
      <div className={`logo-overlay ${!visible ? 'fade-out' : ''}`}>
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo animate" />
        </div>
          {children && <div className="logo-button">{children}</div>}
      </div>
    )
  );
};

export default AnimatedLogo;
